<div class="modal-component small">
    <div class="modal-header-content">
        <div class="header-text-container">
            <div class="header-text">
                Passwort zurücksetzen
            </div>
        </div>
        <button class="modal-close-button" type="button" (click)="onClose()">
            <i class="fa-solid fa-times icon-center"></i>
        </button>
    </div>
    <div class="modal-body-container">
        <div class="my-8">
            <div class="text">
                Bitte geben Sie Ihre E-Mailadresse ein, um das Passwort zurückzusetzen.
            </div>
        </div>
        <div class="form-group">
            <div class="form-control">
                <label>E-Mail</label>
                <input type="email" matInput [formControl]="emailFormControl" [errorStateMatcher]="matcher"
                       placeholder="john.doe@example.com">
                @if (emailFormControl.hasError('required') && !emailFormControl.untouched) {
                    <mat-error>* Pflichtfeld</mat-error>
                } @else if (emailFormControl.hasError('email')) {
                    <mat-error>* E-Mail ist ungültig</mat-error>
                }
            </div>
        </div>
    </div>
    <div class="modal-button-container">
        <button type="button" class="btn-tertiary" (click)="onClose()">Abbrechen</button>
        <button type="button" class="btn-primary" (click)="onSubmit()">Passwort zurücksetzen</button>
    </div>
</div>



